/**
 * Initials avatar with a deterministic colour derived from the name, so a
 * given person reads the same colour everywhere (My Requests holder cells,
 * request detail, user admin). Uses the existing `.avatar` / `.avatar-sm`
 * classes; the background is overridden inline per name.
 */
const AVATAR_COLORS = [
  "#6d5be8",
  "#0e7d6b",
  "#B45309",
  "#9C36B5",
  "#2563eb",
  "#0E7490",
  "#db2777",
  "#7c3aed",
  "#A16207",
];

export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function avatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export interface AvatarProps {
  name: string;
  size?: "sm" | "md";
}

export function Avatar({ name, size = "md" }: AvatarProps) {
  return (
    <span
      className={"avatar" + (size === "sm" ? " avatar-sm" : "")}
      style={{ background: avatarColor(name) }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}

export default Avatar;
